import { W as WuiTag$1, d as defineCustomElement$1 } from './p-BYQE4OHw.js';

const WuiTag = WuiTag$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTag, defineCustomElement };
